import React, { Component } from 'react';
import { connect } from 'react-redux';
import BookingModal from '../../components/Modals/BookingModal';
import AuthModal from '../Modals/AuthModal';

class HeaderWithBooking extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      openModal: false,
    };
  }

  toggle = () => {
    if (this.props.token === null) this.setState({ openModal: true });
    else this.setState({ open: true });
  };

  render() {
    return (
      <div className="pb-3 pt-3">
        <div>{this.props.icon}</div>
        <div>
          <button onClick={this.toggle} className="btn-custom btn-silver">
            Réservation
          </button>
          {this.state.open === true && (
            <BookingModal ToggleModal={() => this.setState({ open: false })} eventsBySlug={this.props.eventsBooking} />
          )}
          {this.state.openModal === true && <AuthModal ToggleModal={() => this.setState({ openModal: false })} />}
        </div>
      </div>
    );
  }
}

export default connect(store => ({ token: store.login.token }), {})(HeaderWithBooking);



// WEBPACK FOOTER //
// ./src/components/leqg/HeaderWithBooking.jsx